import {Currency} from "@/enums/Currency";

export default {
  [Currency.EURO]: '€',
  [Currency.CHF]: 'CHF',
  [Currency.DOLLAR]: '$',
}
